import React, { PropTypes } from 'react';
import { withRouter } from 'react-router';
import locationShape from 'react-router/lib/PropTypes';
import { FormattedMessage } from 'react-intl';

import BcReactComponent from '@bibliocommons/base-bc-react-component';

import { siteShape } from '@bibliocommons/bc-prop-types';
import LibraryLogo from '@bibliocommons/shared-library-logo';

import './LinkableLibrary.scss';

class LinkableLibrary extends BcReactComponent {

  getUrlForLink() {
    const { location, library, linked } = this.props;
    return linked ?
      `${library.get('baseUrl')}${location.pathname}${location.search}` :
      '/library_accounts';
  }

  getImageBaseUrl() {
    const { coreCdnHost } = this.context;
    return coreCdnHost || '';
  }

  renderStatusText() {
    return this.props.linked ?
      <FormattedMessage id="account_linking_status_linked" /> :
      <FormattedMessage id="account_linking_status_unlinked" />;
  }

  renderLinkText() {
    return this.props.linked ?
      <FormattedMessage id="view_account" /> :
      <FormattedMessage id="connect_card" />;
  }

  renderLink() {
    return !this.props.withoutLinks && (
      <a href={this.getUrlForLink()}>
        {this.renderLinkText()}
      </a>
    );
  }

  render() {
    return (
      <li className="cp-linkable-library">
        <LibraryLogo
          siteId={this.props.library.get('siteId')}
          imageName={'account_linking_image'}
          small
          circled
          baseUrl={this.getImageBaseUrl()} />
        <div className="library-info">
          <div className="library-name">
            {this.props.library.get('longName')}
          </div>
          <div className="status">
            {this.renderStatusText()}
          </div>
          <div>
            {this.renderLink()}
          </div>
        </div>
      </li>
    );
  }
}

LinkableLibrary.propTypes = {
  library: siteShape,
  linked: PropTypes.bool,
  location: PropTypes.shape(locationShape),
  withoutLinks: PropTypes.bool
};

LinkableLibrary.contextTypes = {
  coreCdnHost: PropTypes.string
};

export default withRouter(LinkableLibrary);



// WEBPACK FOOTER //
// ./app/components/borrowing/sidebar/LinkableLibrary/LinkableLibrary.jsx